import * as React from "react";
import { Modal, Form, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton } from "soprasteria-ui-library";
import { PatientAttachmentApi } from "../../../../api/PatientAttachmentApi";
import { useAuth } from "../../../../App";
import { LibrettoFileUpload } from "../../../FileUpload/LibrettoFileUpload";

interface IUploadPatientAttachmentsModal {
    patientId: number;
    onSubmitSuccess: () => void;
    onSubmitError: (errorMessage: string) => void;
    onCloseModal: () => void;
}

export const UploadPatientAttachmentsModal: React.FunctionComponent<IUploadPatientAttachmentsModal> = ({ patientId, onSubmitSuccess, onSubmitError, onCloseModal }) => {

    const auth = useAuth();
    const api = new PatientAttachmentApi(auth);

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    React.useEffect(() => {
        document.getElementById("open-upload-patient-attachments-modal")?.click();
    }, [])

    const uploadPatientAttachments = (data: any) => {
        setIsSubmitting(true);

        api.uploadPatientAttachments(patientId, data, () => {
            document.getElementById("close-upload-patient-attachments-modal")?.click();
            onSubmitSuccess();
        }, (message) => {
            document.getElementById("close-upload-patient-attachments-modal")?.click();
            onSubmitError(message);
        });
    }
    
    return (
        <Modal id="upload-patient-attachments-modal" header="Ladda upp TVE-dokument" modalSize={ModalSize.large}>
            <Form onSubmit={uploadPatientAttachments}>
                <ModalBody>
                    <LibrettoFileUpload isEditable={false} attachmentCategories={undefined} />
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton
                            buttonType={ButtonType.general}
                            buttonText="Avbryt"
                            data-dismiss="modal"
                            id="close-upload-patient-attachments-modal"
                            onClick={() => onCloseModal()} />
                        <CustomSubmitButton isLoading={isSubmitting}>Spara</CustomSubmitButton>
                    </div>
                    <input type="hidden" data-toggle="modal" id="open-upload-patient-attachments-modal" data-target="#upload-patient-attachments-modal" />
                </ModalFooter>
            </Form>
        </Modal>
    );
}